import { EstimatedAnnualRevenue } from '@vendasta/account-group';
import { SelectInputOptionInterface } from '@vendasta/galaxy/input';

const options: SelectInputOptionInterface[] = [
  {
    value: EstimatedAnnualRevenue.ESTIMATED_ANNUAL_REVENUE_0_1M.toString(),
    label: 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.OPTION_LABELS.REVENUE.0_1M',
  },
  {
    value: EstimatedAnnualRevenue.ESTIMATED_ANNUAL_REVENUE_1M_10M.toString(),
    label: 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.OPTION_LABELS.REVENUE.1M_10M',
  },
  {
    value: EstimatedAnnualRevenue.ESTIMATED_ANNUAL_REVENUE_10M_50M.toString(),
    label: 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.OPTION_LABELS.REVENUE.10M_50M',
  },
  {
    value: EstimatedAnnualRevenue.ESTIMATED_ANNUAL_REVENUE_50M_100M.toString(),
    label: 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.OPTION_LABELS.REVENUE.50M_100M',
  },
  {
    value: EstimatedAnnualRevenue.ESTIMATED_ANNUAL_REVENUE_100M_250M.toString(),
    label: 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.OPTION_LABELS.REVENUE.100M_250M',
  },
  {
    value: EstimatedAnnualRevenue.ESTIMATED_ANNUAL_REVENUE_250M_500M.toString(),
    label: 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.OPTION_LABELS.REVENUE.250M_500M',
  },
  {
    value: EstimatedAnnualRevenue.ESTIMATED_ANNUAL_REVENUE_500M_1B.toString(),
    label: 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.OPTION_LABELS.REVENUE.500M_1B',
  },
  {
    value: EstimatedAnnualRevenue.ESTIMATED_ANNUAL_REVENUE_1B_10B.toString(),
    label: 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.OPTION_LABELS.REVENUE.1B_10B',
  },
  {
    value: EstimatedAnnualRevenue.ESTIMATED_ANNUAL_REVENUE_10B_OR_MORE.toString(),
    label: 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.OPTION_LABELS.REVENUE.10B_OR_MORE',
  },
];

export default options;
